<script>
import { mapActions } from 'vuex';
import BaseAutocompleteFilter from '@/modules/_global/_components/filters/BaseAutocompleteFilter';

export default {
  name: 'BuildingFilter',

  extends: BaseAutocompleteFilter,

  methods: {
    ...mapActions('smarthome', ['getBuildings']),

    getData() {
      return this.getBuildings({ search: this.search }).then(({ data }) => {
        return data.data;
      });
    }
  }
};
</script>
